import { type CurrencyData, type CurrencyHandlers } from '@ctct/application-layer';
import { CurrencySelect } from '@ctct/payflow-ui';
import type { CurrencyHooks } from '@ctct/state-client-layer';

interface Props {
  data: CurrencyData;
  handlers: CurrencyHandlers;
  hooks: CurrencyHooks;
  isSingleBillChildAccount?: boolean;
}

export const CurrencyWidgetContent = ({ data, handlers, hooks, isSingleBillChildAccount }: Props) => {
  const disabled = Boolean(hooks.useDisabled() || isSingleBillChildAccount);

  const currencyOptions = data.getCurrencyOptions();
  const currency = data.getCurrency();

  return (
    <CurrencySelect
      options={currencyOptions}
      currency={currency}
      onSelect={handlers.onCurrencyChange}
      disabled={disabled}
    />
  );
};
